import Vue from 'vue'
import './hammer.min.js'

function vueHammer(el, type, binding, eventType) {
  this.el = el
  this.type = type
  this.binding = binding
  this.eventType = eventType
  //直接调用
  if (eventType === 'doubletap') {
    var hammertime = new Hammer.Manager(this.el)
    hammertime.add(
      new Hammer.Tap({
        event: 'doubletap',
        taps: 2
      })
    )
    // hammertime.add(
    //   new Hammer.Tap({
    //     event: 'singletap'
    //   })
    // )
    // hammertime.get('doubletap').requireFailure('singletap')
    // hammertime.get('singletap').requireFailure('doubletap')
    return hammertime.on('doubletap', this.binding.value)
  } else if (eventType === 'singletap') {
    var hammertime = new Hammer.Manager(this.el)
    hammertime.add(
      new Hammer.Tap({
        event: 'doubletap',
        taps: 2
      })
    )
    hammertime.add(
      new Hammer.Tap({
        event: 'singletap'
      })
    )
    hammertime.get('doubletap').requireFailure('singletap')
    hammertime.get('singletap').requireFailure('doubletap')
    return hammertime.on('singletap', this.binding.value)
  } else {
    var hammertime = new Hammer(this.el)
  }
  hammertime.on(this.type, this.binding.value)
  if (this.eventType === 'pinch') {
    hammertime.get('pinch').set({ enable: true })
  }
}

const swipe = Vue.directive('swipe', {
  bind: function(el, binding) {
    new vueHammer(el, 'swipe', binding)
  }
})

const swipeleft = Vue.directive('swipeleft', {
  bind: function(el, binding) {
    new vueHammer(el, 'swipeleft', binding)
  }
})

const swiperight = Vue.directive('swiperight', {
  bind: function(el, binding) {
    new vueHammer(el, 'swiperight', binding)
  }
})

const dbtap = Vue.directive('dbtap', {
  bind: function(el, binding) {
    new vueHammer(el, 'doubletap', binding, 'doubletap')
  }
})
const singletap = Vue.directive('singletap', {
  bind: function(el, binding) {
    new vueHammer(el, 'singletap', binding, 'singletap')
  }
})

const tap = Vue.directive('tap', {
  bind: function(el, binding) {
    new vueHammer(el, 'tap', binding)
  }
})

const panstart = Vue.directive('panstart', {
  bind: function(el, binding) {
    new vueHammer(el, 'panstart', binding)
  }
})
const panmove = Vue.directive('panmove', {
  bind: function(el, binding) {
    new vueHammer(el, 'panmove', binding)
  }
})

const panend = Vue.directive('panend', {
  bind: function(el, binding) {
    new vueHammer(el, 'panend', binding)
  }
})
//手指捏放
const pinchstart = Vue.directive('pinchstart', {
  bind: function(el, binding) {
    new vueHammer(el, 'pinchstart', binding, 'pinch')
  }
})
const pinchmove = Vue.directive('pinchmove', {
  bind: function(el, binding) {
    new vueHammer(el, 'pinchmove', binding, 'pinch')
  }
})
const pinchend = Vue.directive('pinchend', {
  bind: function(el, binding) {
    new vueHammer(el, 'pinchend', binding, 'pinch')
  }
})
//导出需要的指令
export { dbtap, tap, singletap, swipe, swipeleft, swiperight, panstart, panmove, panend, pinchstart, pinchmove, pinchend }
